import React from 'react';
import { UnlockOutlined } from '@duxton-web/icons';
import { Button } from 'antd';

import Service from '../../lib/App';
import { IdpRequest } from '../../lib/SAMLDTOs';

interface OwnProps {
  service: string;
}

interface StateProps {}

type SSOLoginProps = OwnProps & StateProps;

interface SSOLoginState {
  isLoading: boolean;
}

export class SSOLogin extends React.Component<SSOLoginProps, SSOLoginState> {
  componentDidMount() {
    this.setState({
      isLoading: false,
    });
  }
  render() {
    return (
      <Button
        size="large"
        type="primary"
        icon={<UnlockOutlined />}
        onClick={() => this.signIn()}
      >
        Login via SSO
      </Button>
    );
  }

  private signIn = async () => {
    const { service } = this.props;
    const encoded = encodeURIComponent(window.location.origin);
    const req: IdpRequest = { service: service, url: encoded };
    // Get idp provider
    Service.saml!.getIdentityProvider(req);
  };
}
